import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  deleteModalTitle: {
    id: 'course-authoring.release-notes.delete-modal.title',
    defaultMessage: 'Delete post?',
  },
  deleteModalDescription: {
    id: 'course-authoring.release-notes.delete-modal.description',
    defaultMessage: 'Are you sure you want to delete this post?',
  },
  cancelButton: {
    id: 'course-authoring.release-notes.delete-modal.cancel',
    defaultMessage: 'Cancel',
  },
  deleteButton: {
    id: 'course-authoring.release-notes.delete-modal.delete',
    defaultMessage: 'Delete',
  },
});

export default messages;
